import { createAsyncThunk } from '@reduxjs/toolkit';
import { getContactsBoardApi, getSummaryDetailContactApi } from 'api/contacts';
import { makeActions } from 'redux/crudCreator/actions';
import { convertRequestParams } from 'redux/crudCreator/dataProvider';
import { apiWrapper } from 'utils/reduxUtils';

export const MODEL_NAME = 'contacts';
export const contactsActions = makeActions(MODEL_NAME);

export const getAllContacts = contactsActions.getAll;
export const editContacts = contactsActions.edit;
export const createContacts = contactsActions.create;
export const getByIdContacts = contactsActions.getDataById;

export const getSummaryDetailContact = createAsyncThunk<
  unknown,
  { id?: string }
>('contacts/getSummaryDetailContact', async (payload = {}, thunkAPI) => {
  try {
    const response = await apiWrapper({}, getSummaryDetailContactApi, payload);
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getContactsBoard = createAsyncThunk<unknown, unknown>(
  'contacts/getContactsBoard',
  async (payload = {}, thunkApi) => {
    try {
      const convertRequest = convertRequestParams('GET_ALL', payload);

      const response = await apiWrapper(
        {},
        getContactsBoardApi,
        convertRequest,
      );

      return { data: response, success: true };
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);
